import useTranslator from "../../hooks/useTranslator";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

const SkorProtectActivatedPopup = ({ show, onDone }) => {
  const { _t } = useTranslator();

  if (!show) return null;

  return (
    <div
      className="popup-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal"
      style={{ zIndex: 9999 }}
    >
      <div className="sp-activated-card">
        <img src={SkorProtectShield} alt="" className="sp-activated-shield" />
        <h2 className="sp-activated-heading">{_t("skorProtectIsNowActive")}</h2>
        <p className="sp-activated-subheading">
          {_t("skorProtectActivatedNextSteps")}
        </p>
        <div className="sp-activated-points">
          <div className="sp-activated-point">
            <span className="sp-activated-point-icon">
              <CheckRoundedIcon />
            </span>
            <div>
              <h3>{_t("skorProtectCoverageConfirmed")}</h3>
              <p>{_t("skorProtectRentalAgreementUploaded")}</p>
            </div>
          </div>
          <div className="sp-activated-point">
            <span className="sp-activated-point-icon">
              <AccessTimeRoundedIcon />
            </span>
            <div>
              <h3>{_t("skorProtectPolicyIn24To48Hours")}</h3>
              <p>{_t("skorProtectPolicyAvailableInPropertyProfile")}</p>
            </div>
          </div>
        </div>
        <p className="sp-activated-support">
          {_t("haveAnyQuestions")}{" "}
          <a href="https://wa.me/34617662602" target="_blank" rel="noreferrer">
            {_t("contactUsOnWhatsApp")}
          </a>
        </p>
        <button className="sp-activated-btn-done" onClick={onDone}>
          {_t("gotIt")}
        </button>
      </div>
    </div>
  );
};

export default SkorProtectActivatedPopup;
